import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <main>
            <Header
                title="404 Oops! | FortiTeam"
                description="The page you’re looking for went through the background check and didn’t pass. Don’t worry, let’s get you back on track."
                structuredData=""
            />
            <HeroSection
                heading="🕵️ 404: Page Not Found"
                subheading="Looks like this page didn’t clear our compliance screening."
                tagline="But don’t worry — you can still get back to safety!"
            />
            <section style={{ textAlign: 'center', padding: '2rem' }}>
                <p style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>
                    Maybe the page retired early, or it’s still waiting on its references.
                    Either way, you won’t find it here.
                </p>
                <Link
                    to="/"
                    style={{
                        display: 'inline-block',
                        marginTop: '1rem',
                        padding: '0.75rem 1.5rem',
                        borderRadius: '8px',
                        backgroundColor: '#7fe1f1',
                        color: '#1c201f',
                        fontWeight: 'bold',
                        textDecoration: 'none',
                        boxShadow: '0 3px 6px rgba(0,0,0,0.2)',
                        transition: 'transform 0.1s ease-in-out'
                    }}
                    onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    🚀 Take Me Home
                </Link>
                <p style={{ marginTop: '1.5rem', fontStyle: 'italic', color: '#555' }}>
                    (Pro tip: our <Link to="/blogs">blog</Link> never ghosts you.)
                </p>
            </section>
        </main>
    );
}

export default NotFound;
